export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11061.50935c55.jpg";